import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import ar from "./ar.json";
import en from "./en.json";

const dictionaries = { ar, en };

const I18nContext = createContext({
  lang: "ar",
  t: (key) => key,
  raw: (key) => null,
  setLang: () => {},
});

function resolvePath(obj, path) {
  return path.split(".").reduce((acc, part) => {
    if (acc == null) return undefined;
    return acc[part];
  }, obj);
}

export function I18nProvider({ lang, children }) {
  const dict = dictionaries[lang] || dictionaries.ar;

  const value = useMemo(() => {
    const t = (key, fallback) => {
      const v = resolvePath(dict, key);
      if (v === undefined || v === null) return fallback ?? key;
      return v;
    };
    const raw = (key) => resolvePath(dict, key);
    return { lang, t, raw, dict };
  }, [lang, dict]);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
    }
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
